module.exports = __webpack_public_path__ + "static/media/snowplow.900e8a0d.svg";